export const EnvironmentUrl = {
    EARNIPAY_LOCAL: 'localhost',
    EARNIPAY_DEVELOP: 'employer-dev.earnipay.com',
    EARNIPAY_STAGING: 'employer-stg.earnipay.com',
    EARNIPAY_PRODUCTION: 'business.earnipay.com',
}

export const getUrl = () => {
    const url = window.location.href;
    const { hostname } = new URL(url);
    return hostname;
}